<template>
    <v-dialog
        v-model="visible"
        :show="true"
        persistent
        :max-width="585"
        overlay-color="#2c2c38"
        :overlay-opacity="0.8"
    >
        <v-card class="subscription">
            <v-card-title class="subscription-heading error">{{ $t('subscription.heading') }}</v-card-title>

            <v-card-text v-if="subscriptionStatus !== 'active'" class="subscription-content">
                <v-alert
                    class="subscription-alert"
                    prominent
                    color="error"
                    type="error"
                    text
                >
                    <span v-if="subscriptionStatus === 'trial_expired'">{{ $t('subscription.trial_expired') }}</span>
                    <span v-else-if="subscriptionStatus === 'expired_contact_support'">{{ $t('subscription.expired_contact_support') }}</span>
                    <span v-else-if="subscriptionStatus === 'disabled_contact_support'">{{ $t('subscription.disabled_contact_support') }}</span>
                </v-alert>

                <div class="flex justify-center mt-6 mb-1">
                    <v-btn
                        class="white--text"
                        color="error"
                        depressed
                        large
                        @click="logoutTenant()"
                    >
                        <v-icon class="mr-2" size="20">fal fa-sign-out</v-icon>
                        {{ $t('general.log_out') }}
                    </v-btn>
                </div>
            </v-card-text>

            <v-card-text v-else class="subscription-content">
                <v-alert
                    class="subscription-alert"
                    prominent
                    color="error"
                    type="error"
                    text
                >
                    <div v-if="shouldShowDebtAmount()">
                        <span>
                            <strong>{{ $t('subscription.debt_amount', { value: debt.toFormat(), software: isAllegra ? 'Allegra' : 'Aria' }) }}</strong>
                            <br>
                        </span>
                        <span>{{ $t('subscription.debt_settle') }} </span>
                        <span>{{ $t('subscription.debt_invoices') }}</span>
                    </div>
                    <div v-else>
                        <span>{{ $t('subscription.debt_settle_reseller', { software: isAllegra ? 'Allegra' : 'Aria' }) }} </span>
                    </div>
                </v-alert>

                <div class="flex justify-center mt-6 mb-1">
                    <v-btn
                        class="white--text"
                        color="error"
                        depressed
                        large
                        @click="hide()"
                    >
                        {{ $t('general.close') }}
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>
import TenantService from '@/services/TenantService';

const DEBT_WARNING_SEEN = 'debt-warning-seen'

export default {
    created() {
        if(process.env.VUE_APP_ENABLE_BILLING !== 'true') return

        this.debt = this.tenant && this.tenant.company
            ? Money.parse(this.tenant.company.amount_due)
            : Money.parse(0)

        if(this.shouldShowDebtWarning()) {
            this.visible = true
        }

        this.eventBus.$on('subscription-expired', this.onSubscriptionExpired);
    },

    beforeDestroy() {
        this.eventBus.$off('subscription-expired', this.onSubscriptionExpired);
    },

    data() {
        return {
            visible: false,
            debt: Money.parse(0),
        };
    },

    watch: {
        tenant() {
            if(process.env.VUE_APP_ENABLE_BILLING !== 'true') return

            this.debt = this.tenant && this.tenant.company
                ? Money.parse(this.tenant.company.amount_due)
                : Money.parse(0)

            if(this.shouldShowDebtWarning()) {
                this.visible = true
            }
        }
    },

    computed: {
        subscriptionStatus() {
            if(this.tenant.status === 'expired') {
                return this.tenant.tenant_contracts && this.tenant.tenant_contracts.length
                    ? 'expired_contact_support'
                    : 'trial_expired'
            } else if(this.tenant.status === 'disabled') {
                return 'disabled_contact_support'
            } else {
                return 'active';
            }
        },
    },

    methods: {
        async onSubscriptionExpired() {
            if(this.subscriptionStatus === 'active') {
                await this.reloadTenant();
            }

            this.visible = true
        },

        hide() {
            this.visible = false;
        },

        shouldShowDebtWarning() {
            if(this.debt.toUnit() < 2) return false;

            if(moment().hour() <= 5) return false

            const today = moment().format('YYYY-MM-DD')
            const debtWarningSeenAt = AppStorage.local().getItem(DEBT_WARNING_SEEN);

            if(!debtWarningSeenAt || today !== debtWarningSeenAt) {
                AppStorage.local().setItem(DEBT_WARNING_SEEN, today);
                return true
            }

            return false
        },

        shouldShowDebtAmount() {
            return this.tenant
                && this.tenant.company
                && this.tenant.company.latest_invoice
                && this.tenant.company.latest_invoice.path
        },

        async reloadTenant(){
            const response = await ApiService.get('/me');
            TenantService.setTenant(response.data);
        },

        /**
         * Log out Tenant
         */
        logoutTenant() {
            TenantService.logout();
            this.$router.push({ name: 'tenantLogin' }).catch(err => {});
        },
    }
};
</script>

<style lang="scss" scoped>
.subscription {
    display: flex;
    flex-direction: column;

    .subscription-heading {
        color: white;
        justify-content: center;
        font-weight: 400;
        font-size: 22px;
        padding: 12px;
    }

    .subscription-content {
        padding: 24px;

        .subscription-alert {
            color: black !important;
            border: 1px solid #e8e8e8;

            &:before {
                background: #cccccc !important;
            }
        }
    }
}
</style>
